import * as React from 'react';

export default function Surface({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 20 20'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.98 15.8057C10.6602 16.0544 10.2071 16.0544 9.88729 15.8057L4.42365 11.5591C4.10383 11.3104 3.65963 11.3104 3.33981 11.5591C2.88673 11.9145 2.88673 12.5986 3.33981 12.9539L9.34536 17.6269C9.98501 18.1244 10.8823 18.1244 11.5308 17.6269L17.5364 12.9539C17.9895 12.5986 17.9895 11.9145 17.5364 11.5591L17.5275 11.5502C17.2077 11.3015 16.7635 11.3015 16.4436 11.5502L10.98 15.8057ZM11.5397 13.1227L17.5453 8.44975C17.9983 8.09439 17.9983 7.40144 17.5453 7.04609L11.5397 2.37313C10.9001 1.87562 10.0028 1.87562 9.35425 2.37313L3.3487 7.05497C2.89561 7.41033 2.89561 8.10328 3.3487 8.45863L9.35425 13.1316C9.99389 13.6291 10.9001 13.6291 11.5397 13.1227Z"
        fill="currentColor"
      />
    </svg>
  );
}
